export const ALL_TEMPLATES = 'ALL_TEMPLATES'
export const CATEGORY_TEMPLATES = 'CATEGORY_TEMPLATES'
export const SIMILAR_CATEGORY_TEMPLATES = 'SIMILAR_CATEGORY_TEMPLATES'

export const TEMPLATES_NULL = 'TEMPLATES_NULL'
export const GET_TEMPLATE_DETAIL= 'GET_TEMPLATE_DETAIL'
export const FORM_CREATED_VIA_TEMPLATE = 'FORM_CREATED_VIA_TEMPLATE'

export const FORM_VIA_TEMPLATE_AFTER_AUTH = 'FORM_VIA_TEMPLATE_AFTER_AUTH'
export const ALL_TEMPLATE_USE_CASES = "ALL_TEMPLATE_USE_CASES"
export const ALL_TEMPLATE_SUITABLE_FOR = "ALL_TEMPLATE_SUITABLE_FOR"
export const FETCH_TEMPLATE_DETAIL_BY_SLUG = "FETCH_TEMPLATE_DETAIL_BY_SLUG";